import React from 'react';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';

const VideoMessageAttachment = () => (<OndemandVideoIcon />);

export default VideoMessageAttachment;
